export default {
  categories: state => state.categories,
  customCategories: state => state.customCategories,
  defaultCategoriesOffice: state => state.defaultCategoriesOffice,
  userRecentCategories: state => state.userRecentCategories,
  filters: state => state.filters,
  isCallingCategories: state => state.isCallingCategories,
  currentPage: state => state.currentPage
}
